const ENOKR = {
	"Comprimir todos resultados chave": "Compress all key results",
	"Erro ao carregar a hierarquia": "Error loading hierarchy",
	"Erro ao carregar os OKRs" : "Error loading the OKRs",
	"Expandir todos resultados chave": "Expand all key results",
	"Meus OKRs": "My OKRs",
	"Todos OKRs": "All OKRs"
};

export default ENOKR;
